import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        texts: {
            danish: 'Kære kunde<br><br>Mange tak for din henvendelse til os. Vi har registreret den i vores system og vi vender tilbage til dig, så du skal ikke gøre mere.<br><br>I øjeblikket kan du desværre opleve lidt længere svartid men vi arbejder hårdt på at kunne nedbringe den.<br><br>Vi håber på din tålmodighed og glæder os til at kunne hjælpe dig.<br><br>Med venlig hilsen Quooker Aftersales.<br><br>',
            swedish: 'Tak. Vi har nu modtaget din henvendelse.<br><br>Du kan normalt forvente at høre fra os inden for 6-8 arbejdsdage.',
            norwegian: 'Takk. Vi har mottatt din henvendelse.<br><br>Den forventede svartid er 2-4 arbeidsdager.',
            icelandic: 'Takk. Við höfum fengið fyrirspurn þína.<br><br>Áætlaður svartími er 6-8 virkir dagar.'
        },
        form: {
            attachments: [],
            meta: {
                id: null
            },
            container: {
                serial: null
            },
            validatedContainer: null,
            validatedFaucet: null,
            cube: {
                own: null,
                serial: null
            },
            faucet: {
                type: null,
                surface: null,
                meta: null,
                serial: null
            },
            problem: {
                questions: [
                    {
                        question: 'Kommer der vand ud af hanen?',
                        questionNO: 'Kommer det vann ut av kranen?',
                        questionIS: 'Kemur vatn úr blöndunartækinu?',
                        answer: null
                    },
                    {
                        question: 'Er vandet kogende?',
                        questionNO: 'Er vannet kokende?',
                        questionIS: 'Er vatnið að sjóða?',
                        answer: null
                    },
                    {
                        question: 'Blinker Quooker hanen?',
                        questionNO: 'Blinker Quooker-kranen?',
                        questionIS: 'Blikar Quooker blöndunartækið?',
                        answer: null,
                        extra: null
                    },
                    {
                        question: 'Nulstilling af Quooker er forsøgt?',
                        questionNO: 'Quooker startet på nytt?',
                        questionIS: 'Quooker endurræstur?',
                        slug: 'restart',
                        answer: null,
                        extra: null
                    }
                ],
                description: null
            },
            warranty: {
                underWarranty: null,
                installationMonth: null,
                installationYear: null
            },
            contact: {
                company: null,
                name: null,
                firstname: null,
                lastname: null,
                email: null,
                phone: null,
                address: null,
                validatedAddress: null
            },
            terms: {
                accepted: false
            },
            default: {
                email: 'service@quooker.dk'
            }
        }
    },
    modules: {
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js